<template>
  <div class="coupon-management">
    <div class="page-header">
      <h2>优惠券管理</h2>
      <el-button type="primary" @click="showCreateDialog">新增优惠券</el-button>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">优惠券总数</div>
          <div class="stat-value">{{ statistics.total_coupons || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已启用</div>
          <div class="stat-value stat-value-success">{{ statistics.enabled_coupons || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已禁用</div>
          <div class="stat-value stat-value-warning">{{ statistics.disabled_coupons || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已领取</div>
          <div class="stat-value stat-value-primary">{{ statistics.total_receive_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已使用</div>
          <div class="stat-value stat-value-info">{{ statistics.total_use_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">使用率</div>
          <div class="stat-value stat-value-purple">{{ statistics.use_rate || 0 }}%</div>
        </div>
      </el-card>
    </div>

    <!-- 搜索表单 -->
    <el-form :inline="true" :model="searchForm" class="search-form">
      <el-form-item label="优惠券名称">
        <el-input v-model="searchForm.coupon_name" placeholder="请输入优惠券名称" clearable />
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select v-model="searchForm.coupon_type" placeholder="请选择优惠券类型" clearable>
          <el-option label="满减券" :value="1" />
          <el-option label="折扣券" :value="2" />
          <el-option label="代金券" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="使用场景">
        <el-select v-model="searchForm.use_scene" placeholder="请选择使用场景" clearable>
          <el-option label="全场通用" :value="1" />
          <el-option label="指定分类" :value="2" />
          <el-option label="指定商品" :value="3" />
          <el-option label="指定店铺" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
          <el-option label="启用" :value="1" />
          <el-option label="禁用" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="couponList" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="coupon_name" label="优惠券名称" min-width="150" />
      <el-table-column prop="coupon_type" label="优惠券类型" width="100">
        <template slot-scope="scope">
          <el-tag :type="getCouponTypeTagType(scope.row.coupon_type)">
            {{ getCouponTypeName(scope.row.coupon_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="discount_type" label="优惠类型" width="100">
        <template slot-scope="scope">
          <el-tag type="info" size="small">
            {{ scope.row.discount_type == 1 ? '金额' : '折扣' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="discount_value" label="优惠值" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.discount_type == 1">
            ¥{{ scope.row.discount_value }}
          </span>
          <span v-else>
            {{ scope.row.discount_value }}折
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="min_amount" label="最低消费" width="100">
        <template slot-scope="scope">
          ¥{{ scope.row.min_amount || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="total_count" label="发行总量" width="100" />
      <el-table-column prop="receive_count" label="已领取" width="80" />
      <el-table-column prop="use_count" label="已使用" width="80" />
      <el-table-column prop="per_limit" label="每人限领" width="80" />
      <el-table-column prop="use_scene" label="使用场景" width="100">
        <template slot-scope="scope">
          {{ getUseSceneName(scope.row.use_scene) }}
        </template>
      </el-table-column>
      <el-table-column prop="validity_period" label="有效期" width="180">
        <template slot-scope="scope">
          <div style="font-size: 12px;">
            {{ scope.row.start_time }} 至<br/>{{ scope.row.end_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status == 1 ? 'success' : 'info'">
            {{ scope.row.status == 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort_order" label="排序" width="80" />
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <div class="table-operations">
            <el-button size="mini" type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" type="text" class="edit-btn" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleChangeStatus(scope.row)">
              {{ scope.row.status == 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button size="mini" type="text" class="delete-btn" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.limit"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 创建/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px">
      <el-form ref="couponForm" :model="couponForm" :rules="couponRules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="优惠券名称" prop="coupon_name">
              <el-input v-model="couponForm.coupon_name" placeholder="请输入优惠券名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券类型" prop="coupon_type">
              <el-select v-model="couponForm.coupon_type" placeholder="请选择优惠券类型" style="width: 100%">
                <el-option label="满减券" :value="1" />
                <el-option label="折扣券" :value="2" />
                <el-option label="代金券" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="优惠券描述">
          <el-input v-model="couponForm.coupon_desc" type="textarea" :rows="2" placeholder="请输入优惠券描述" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="优惠类型" prop="discount_type">
              <el-select v-model="couponForm.discount_type" placeholder="请选择优惠类型" style="width: 100%">
                <el-option label="金额" :value="1" />
                <el-option label="折扣" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠值" prop="discount_value">
              <el-input-number
                v-model="couponForm.discount_value"
                :min="0.01"
                :max="couponForm.discount_type == 2 ? 9.9 : 99999.99"
                :precision="couponForm.discount_type == 2 ? 1 : 2"
                style="width: 100%"
              />
              <span style="margin-left: 10px; color: #909399;">
                {{ couponForm.discount_type == 1 ? '元' : '折' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最低消费金额">
              <el-input-number v-model="couponForm.min_amount" :min="0" :precision="2" style="width: 100%" />
              <span style="margin-left: 10px; color: #909399;">元</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大优惠金额" v-if="couponForm.discount_type == 2">
              <el-input-number v-model="couponForm.max_discount" :min="0" :precision="2" style="width: 100%" />
              <span style="margin-left: 10px; color: #909399;">元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发行总量" prop="total_count">
              <el-input-number v-model="couponForm.total_count" :min="1" style="width: 100%" />
              <span style="margin-left: 10px; color: #909399;">0表示不限制</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每人限领">
              <el-input-number v-model="couponForm.per_limit" :min="0" style="width: 100%" />
              <span style="margin-left: 10px; color: #909399;">0表示不限制</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用场景" prop="use_scene">
              <el-select v-model="couponForm.use_scene" placeholder="请选择使用场景" style="width: 100%" @change="handleUseSceneChange">
                <el-option label="全场通用" :value="1" />
                <el-option label="指定分类" :value="2" />
                <el-option label="指定商品" :value="3" />
                <el-option label="指定店铺" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场景值" v-if="couponForm.use_scene != 1">
              <el-input v-model="couponForm.scene_value" :placeholder="getSceneValuePlaceholder()" />
              <div style="color: #909399; font-size: 12px; margin-top: 5px;">
                {{ getSceneValueTip() }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="start_time">
              <el-date-picker
                v-model="couponForm.start_time"
                type="datetime"
                placeholder="选择开始时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="startDateOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="end_time">
              <el-date-picker
                v-model="couponForm.end_time"
                type="datetime"
                placeholder="选择结束时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="endDateOptions"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="couponForm.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="couponForm.sort_order" :min="0" :max="9999" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog title="优惠券详情" :visible.sync="viewDialogVisible" width="900px">
      <div v-if="currentCoupon" class="coupon-detail">
        <!-- 基本信息 -->
        <div class="detail-section">
          <div class="section-title">基本信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">优惠券ID</div>
              <div class="detail-value">{{ currentCoupon.id }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">优惠券名称</div>
              <div class="detail-value">{{ currentCoupon.coupon_name }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">优惠券描述</div>
              <div class="detail-value">{{ currentCoupon.coupon_desc || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">优惠券类型</div>
              <div class="detail-value">
                <el-tag :type="getCouponTypeTagType(currentCoupon.coupon_type)">
                  {{ getCouponTypeName(currentCoupon.coupon_type) }}
                </el-tag>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">优惠类型</div>
              <div class="detail-value">{{ currentCoupon.discount_type == 1 ? '金额' : '折扣' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">优惠值</div>
              <div class="detail-value">
                <span v-if="currentCoupon.discount_type == 1">¥{{ currentCoupon.discount_value }}</span>
                <span v-else>{{ currentCoupon.discount_value }}折</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">最低消费金额</div>
              <div class="detail-value">¥{{ currentCoupon.min_amount || 0 }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">最大优惠金额</div>
              <div class="detail-value">¥{{ currentCoupon.max_discount || 0 }}</div>
            </div>
          </div>
        </div>

        <!-- 数量信息 -->
        <div class="detail-section">
          <div class="section-title">数量信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">发行总量</div>
              <div class="detail-value">{{ currentCoupon.total_count == 0 ? '不限制' : currentCoupon.total_count }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">已领取数量</div>
              <div class="detail-value">
                <span class="stat-value">{{ currentCoupon.receive_count || 0 }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">已使用数量</div>
              <div class="detail-value">
                <span class="stat-value">{{ currentCoupon.use_count || 0 }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">剩余数量</div>
              <div class="detail-value">
                <span class="stat-value">{{ currentCoupon.total_count == 0 ? '不限制' : Math.max(0, currentCoupon.total_count - currentCoupon.receive_count) }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">每人限领</div>
              <div class="detail-value">{{ currentCoupon.per_limit == 0 ? '不限制' : currentCoupon.per_limit }}</div>
            </div>
          </div>
        </div>

        <!-- 使用信息 -->
        <div class="detail-section">
          <div class="section-title">使用信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">使用场景</div>
              <div class="detail-value">{{ getUseSceneName(currentCoupon.use_scene) }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">场景值</div>
              <div class="detail-value">{{ currentCoupon.scene_value || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">开始时间</div>
              <div class="detail-value">{{ currentCoupon.start_time }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">结束时间</div>
              <div class="detail-value">{{ currentCoupon.end_time }}</div>
            </div>
          </div>
        </div>

        <!-- 其他信息 -->
        <div class="detail-section">
          <div class="section-title">其他信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">状态</div>
              <div class="detail-value">
                <el-tag :type="currentCoupon.status == 1 ? 'success' : 'info'">
                  {{ currentCoupon.status == 1 ? '启用' : '禁用' }}
                </el-tag>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">排序</div>
              <div class="detail-value">{{ currentCoupon.sort_order }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">创建时间</div>
              <div class="detail-value">{{ currentCoupon.create_time }}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="handleEditFromDetail">编辑</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCouponList, getCouponDetail, createCoupon, updateCoupon, deleteCoupon, changeCouponStatus, getCouponStatistics } from '@/api/coupon'

export default {
  name: 'CouponManagement',
  data() {
    return {
      loading: false,
      couponList: [],
      statistics: {},
      searchForm: {
        coupon_name: '',
        coupon_type: '',
        use_scene: '',
        status: ''
      },
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      dialogVisible: false,
      viewDialogVisible: false,
      dialogTitle: '新增优惠券',
      currentCoupon: null,
      couponForm: {
        id: null,
        coupon_name: '',
        coupon_type: 1,
        coupon_desc: '',
        discount_type: 1,
        discount_value: 10,
        min_amount: 0,
        max_discount: 0,
        total_count: 100,
        per_limit: 1,
        use_scene: 1,
        scene_value: '',
        start_time: '',
        end_time: '',
        status: 1,
        sort_order: 100
      },
      couponRules: {
        coupon_name: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        coupon_type: [
          { required: true, message: '请选择优惠券类型', trigger: 'change' }
        ],
        discount_type: [
          { required: true, message: '请选择优惠类型', trigger: 'change' }
        ],
        discount_value: [
          { required: true, message: '请输入优惠值', trigger: 'blur' }
        ],
        total_count: [
          { required: true, message: '请输入发行总量', trigger: 'blur' }
        ],
        use_scene: [
          { required: true, message: '请选择使用场景', trigger: 'change' }
        ],
        start_time: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        end_time: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    startDateOptions() {
      return {
        disabledDate: (time) => {
          if (this.couponForm.end_time) {
            return time.getTime() > new Date(this.couponForm.end_time).getTime()
          }
          return false
        }
      }
    },
    endDateOptions() {
      return {
        disabledDate: (time) => {
          if (this.couponForm.start_time) {
            return time.getTime() < new Date(this.couponForm.start_time).getTime()
          }
          return false
        }
      }
    }
  },
  mounted() {
    this.fetchCouponList()
    this.fetchStatistics()
  },
  methods: {
    async fetchCouponList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.searchForm
        }
        const response = await getCouponList(params)
        this.couponList = response.data.list || []
        this.pagination.total = response.data.total || 0
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    async fetchStatistics() {
      try {
        const response = await getCouponStatistics()
        this.statistics = response.data || {}
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchCouponList()
    },
    handleReset() {
      this.searchForm = {
        coupon_name: '',
        coupon_type: '',
        use_scene: '',
        status: ''
      }
      this.pagination.page = 1
      this.fetchCouponList()
    },
    handleSizeChange(size) {
      this.pagination.limit = size
      this.fetchCouponList()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchCouponList()
    },
    showCreateDialog() {
      this.dialogTitle = '新增优惠券'
      this.couponForm = {
        id: null,
        coupon_name: '',
        coupon_type: 1,
        coupon_desc: '',
        discount_type: 1,
        discount_value: 10,
        min_amount: 0,
        max_discount: 0,
        total_count: 100,
        per_limit: 1,
        use_scene: 1,
        scene_value: '',
        start_time: '',
        end_time: '',
        status: 1,
        sort_order: 100
      }
      this.dialogVisible = true
    },
    async handleView(row) {
      try {
        const response = await getCouponDetail(row.id)
        this.currentCoupon = response.data
        this.viewDialogVisible = true
      } catch (error) {
        console.error('获取优惠券详情失败:', error)
      }
    },
    async handleEdit(row) {
      try {
        const response = await getCouponDetail(row.id)
        this.couponForm = response.data
        this.dialogTitle = '编辑优惠券'
        this.dialogVisible = true
      } catch (error) {
        console.error('获取优惠券详情失败:', error)
      }
    },
    async handleChangeStatus(row) {
      const action = row.status == 1 ? '禁用' : '启用'
      this.$confirm(`确认${action}该优惠券吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await changeCouponStatus({ id: row.id, status: row.status == 1 ? 0 : 1 })
          this.$message.success(`${action}成功`)
          this.fetchCouponList()
          this.fetchStatistics()
        } catch (error) {
          console.error(`${action}优惠券失败:`, error)
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该优惠券吗？删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCoupon(row.id)
          this.$message.success('删除成功')
          this.fetchCouponList()
          this.fetchStatistics()
        } catch (error) {
          console.error('删除优惠券失败:', error)
        }
      })
    },
    handleSubmit() {
      this.$refs.couponForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.couponForm.id) {
              await updateCoupon(this.couponForm)
              this.$message.success('更新成功')
            } else {
              await createCoupon(this.couponForm)
              this.$message.success('创建成功')
            }
            this.dialogVisible = false
            this.fetchCouponList()
            this.fetchStatistics()
          } catch (error) {
            console.error('操作失败:', error)
          }
        }
      })
    },
    handleEditFromDetail() {
      this.viewDialogVisible = false
      this.handleEdit(this.currentCoupon)
    },
    handleUseSceneChange() {
      this.couponForm.scene_value = ''
    },
    getCouponTypeName(type) {
      const map = { 1: '满减券', 2: '折扣券', 3: '代金券' }
      return map[type] || '-'
    },
    getCouponTypeTagType(type) {
      const map = { 1: 'primary', 2: 'success', 3: 'warning' }
      return map[type] || ''
    },
    getUseSceneName(scene) {
      const map = { 1: '全场通用', 2: '指定分类', 3: '指定商品', 4: '指定店铺' }
      return map[scene] || '-'
    },
    getSceneValuePlaceholder() {
      const map = { 2: '请输入分类ID，多个用逗号分隔', 3: '请输入商品ID，多个用逗号分隔', 4: '请输入店铺ID，多个用逗号分隔' }
      return map[this.couponForm.use_scene] || ''
    },
    getSceneValueTip() {
      const map = { 2: '示例：1,2,3', 3: '示例：100,200,300', 4: '示例：10,20,30' }
      return map[this.couponForm.use_scene] || ''
    }
  }
}
</script>

<style scoped>
.coupon-management {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

/* 统计卡片 */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  border-radius: 8px;
  overflow: hidden;
}

.stat-card :deep(.el-card__body) {
  padding: 20px;
}

.stat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

.stat-value-success {
  color: #67c23a;
}

.stat-value-warning {
  color: #e6a23c;
}

.stat-value-primary {
  color: #409eff;
}

.stat-value-info {
  color: #909399;
}

.stat-value-purple {
  color: #9b59b6;
}

.search-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.table-operations {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.table-operations .el-button--text {
  padding: 2px 8px;
  font-size: 12px;
  border: none;
  background: none;
}

.table-operations .edit-btn {
  color: #409eff;
}

.table-operations .edit-btn:hover {
  color: #66b1ff;
  background-color: #ecf5ff;
}

.table-operations .delete-btn {
  color: #f56c6c;
}

.table-operations .delete-btn:hover {
  color: #f78989;
  background-color: #fef0f0;
}

.dialog-footer {
  text-align: right;
}

.coupon-detail {
  padding: 10px 0;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
  line-height: 20px;
}

.detail-table {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;
  min-height: 50px;
  align-items: center;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #606266;
  width: 150px;
  text-align: right;
  padding: 15px 20px;
  background-color: #FAFAFA;
  border-right: 1px solid #EBEEF5;
  flex-shrink: 0;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
  word-break: break-word;
  padding: 15px 20px;
  flex: 1;
  box-sizing: border-box;
}

.coupon-detail .stat-value {
  color: #409EFF;
  font-size: 18px;
  font-weight: 600;
}
</style>
